module.exports = __webpack_public_path__ + "static/media/46980011-lNR0wSgs.e3f830d7.JPG";